<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('preorder_processing_overview.page_title') }}</slot>
            <slot slot="description">
                <p>{{ $t('preorder_overview.description') }}</p>
            </slot>
        </page-header>

        <v-overview-list
                data-table="ClosedPreOrders"
                data-filter="PreOrdersFilters"
                data-pagination="PreOrdersPagination"
                btnViewPath="SalesmanPreOrdersEdit"
                filter-theme="white"
                :filters="PreOrders.filters"
                :table-columns="PreOrders.columns"
                :btnCopy="false"
                :btnExportPreOrder="true"
                :btnResendPreOrder="true"
                :page-size="12"
                prefix="lop">
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList
        },
        data() {
          return { }
        },
        computed: {
            PreOrders() {
                return {
                    filters: [
                        { name: this.$t('preorder_overview.filters.brands'), value: 'Brands', single: 'brand', width:150 },
                        { name: this.$t('preorder_overview.filters.collections'), value: 'Collections', single: 'collection', width:150 },
                        { name: this.$t('preorder_overview.filters.customer'), value: 'Customers', single: 'customer', width:150 },
                        { name: this.$t('preorder_overview.filters.system_states'), value: 'SystemStates', single: 'systemState', width:200 }
                    ],
                    columns: [
                        { value: 'SheetName', name: this.$t('preorder_overview.columns.name') },
                        { value: 'CustomerAltKey', name: this.$t('preorder_overview.columns.customer_key') },
                        { value: 'Customer', name: this.$t('preorder_overview.columns.customer') },
                        { value: 'InternalCustomerReference', name: this.$t('preorder_overview.columns.internal_customer_ref') },   
                        { value: 'SalesMan', name: this.$t('preorder_overview.columns.salesman') },                     
                        { value: 'SystemStateDisplay', name: this.$t('preorder_overview.columns.system_state') },
                        { value: 'ProcessDate', name: this.$t('preorder_overview.columns.process_date'), type: 'Date' }
                    ]
                };
            },
        },
        methods: {}
    }

</script>



// WEBPACK FOOTER //
// src/views/admin/preOrders/PreOrderProcessing.vue